import "./WeaveTypes.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import WeavePatternsHero from "./sections/WeavePatternsHero";
import Architectures from "./sections/Architectures";
import Matrix from "./sections/Matrix";
import CustomWeave from "./sections/CustomWeave";
import Footer from "@/reusable_sections/Footer";
export default function WeaveTypesPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="WeaveTypes" />
      <main id="main-content" tabIndex={-1} className="outline-none">
        <WeavePatternsHero />
        <Architectures />
        <Matrix />
        <CustomWeave />
      </main>
      <Footer />
    </div>;
}